module.exports = __webpack_public_path__ + "static/media/SmartphoneIcon.e98fc8dd.svg";